/* eslint-disable func-call-spacing */
const Index = () => import('./Index.vue')
const NavBar = () => import('~components/navbar/NavBar.vue')
const Dashboard = () => import('./Dashboard.vue')
const NewDashboardDialog = () => import('./NewDashboardDialog.vue')

export default [
  {
    path: '/dashboards',
    components: {
      default: Index,
      navbar: NavBar
    },
    meta: {
      access: ['org.report.dashboard.view']
    },
    children: [
      {
        name: 'dashboard',
        path: ':dashboard',
        component: Dashboard,
        meta: {
          access: ['org.report.dashboard.view']
        }
      },
      {
        name: 'new-global-dashboard',
        path: 'new-dashboard',
        components: {
          modal: NewDashboardDialog
        },
        meta: {
          showModal: true,
          access: ['org.report.dashboard.manage']
        }
      }
    ]
  }
]
